import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
} from '@mui/material';
import { createGroup } from '../apis/apis';

export default function CreateGroupDialog({ open, onClose, onGroupCreated }) {
  const [newGroupName, setNewGroupName] = useState('');
  const [error, setError] = useState('');

  const handleCreateGroup = async () => {
    try {
      const newGroup = await createGroup(newGroupName);
      onGroupCreated(newGroup);
      handleClose();
    } catch (error) {
      setError(error.message);
      console.error('Error creating group:', error);
    }
  };

  const handleClose = () => {
    setNewGroupName('');
    setError('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            width: '20vw',
            minWidth: '300px',
            maxWidth: '400px',
            height: 'fit-content'
          }
        }
      }}
    >
      <DialogTitle>Create New Group</DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          autoFocus
          margin="dense"
          label="Group Name"
          fullWidth
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleCreateGroup} variant="contained">Create</Button>
      </DialogActions>
    </Dialog>
  );
} 